import React from 'react';
import AiAvatarCard from '../AiAvatarCard';
import styles from './index.module.less';

interface AvatarContainerProps {
  mode: 'chat' | 'standby'; // 模式：聊天模式或待机模式
  showUserTag?: boolean; // 是否显示用户标签
  className?: string; // 额外的样式类名
  children?: React.ReactNode; // 额外的子元素（如气泡、按钮等）
  onClick?: () => void; // 点击事件
  disabled?: boolean; // 是否禁用点击
  showShadow?: boolean; // 是否显示阴影效果
}

/**
 * 统一的数字人容器组件
 * 支持聊天模式和待机模式，提供一致的布局和样式管理
 */
function AvatarContainer({
  mode,
  showUserTag = false,
  className,
  children,
  onClick,
  disabled = false,
  showShadow = false,
}: AvatarContainerProps) {
  // 根据模式确定容器样式类名
  const containerClass = [
    styles.avatarContainer,
    styles[mode], // chat 或 standby 模式样式
    disabled && styles.disabled,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  // 数字人包装器样式
  const avatarWrapperClass = [styles.avatarWrapper, showShadow && styles.withShadow]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClass} onClick={disabled ? undefined : onClick}>
      {/* 数字人包装器 */}
      <div className={avatarWrapperClass}>
        <AiAvatarCard showUserTag={showUserTag} entryStandbyMode={mode === 'standby'} />
      </div>

      {/* 额外的子元素（气泡、按钮等） */}
      {children}
    </div>
  );
}

export default AvatarContainer;
export type { AvatarContainerProps };
